"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Guide = function Guide() {
  return /*#__PURE__*/_react["default"].createElement("iframe", {
    src: "https://support.quest4data.com/support",
    title: "Quest Support Resources",
    style: {
      width: '100%',
      height: '100vh',
      border: '0px'
    }
  });
};
var _default = exports["default"] = Guide;